// import { useEffect } from 'react';
// import { motion, useAnimation } from 'framer-motion';
// import { useInView } from 'react-intersection-observer';


const Portfolio = () => {
    return (
        <section >
            <p>Portfolio</p>
        </section>
    );
};

export default Portfolio;